/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-10-24 14:25:26
 * @LastEditTime: 2023-06-07 09:51:24
 * @LastEditors: Please set LastEditors
 */
import React, { createRef, useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { FormComponentProps } from 'sup-ui/lib/form';
import { reducerStates } from 'root/store/types';
import { useDispatch, useSelector } from 'react-redux';
import { envManage } from '../../store/actions';
import { UpdateHostListType } from '../types';

import { Input, Button, Spin, Checkbox } from 'sup-ui';
import CreateBaseForm from '../BaseFormModal';
import CommonModal from 'root/components/CommonModal';
import AddBtachFile from 'root/components/AddBtachFile';
import messages from '../messages';
import {
  postHostDataApi,
  getLabelApi,
  exportExcelDownloadApi,
  exportErrorExcelApi,
  getImportedNodeApi,
} from 'root/services/disk';
import { downloadFiles } from 'root/utils/utils';

import styles from './index.less';
import { message } from 'sup-ui';

interface IProps {
  visible: boolean;
  type: string;
  onOk: () => void;
  updateHostList: any;
}

interface LabelType {
  label: string;
  value: string | number;
  disabled?: boolean;
}

type Ref = FormComponentProps;

const field = ({ fmt, labelOptions, setInputValue }: any) => {
  return [
    {
      label: fmt(messages.customHostName),
      key: 'name',
      type: 'text',
      rules: [
        {
          required: true,
          message: fmt(messages.customHostNameRequired),
        },
      ],
    },
    {
      label: fmt(messages.serverAddress),
      key: 'ip',
      type: 'text',
      rules: [
        {
          required: true,
          message: fmt(messages.serverAddressRequired),
        },
        () => ({
          validator: (_: any, value: any, callback: any) => {
            if (!value) return callback();
            const flagIp = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
            if (flagIp.test(value)) {
              return callback();
            } else {
              return callback(fmt(messages.serverAddressRule));
            }
          },
        }),
      ],
    },
    {
      label: fmt(messages.sshPort),
      key: 'sshPort',
      type: 'text',
      rules: [
        {
          required: true,
          message: fmt(messages.sshPortRequire),
        },
      ],
    },
    {
      label: fmt(messages.count),
      key: 'user',
      type: 'text',
      rules: [
        {
          required: true,
          message: fmt(messages.countRequire),
        },
      ],
      formItemProps: {
        disabled: true,
      },
    },
    {
      label: fmt(messages.pwd),
      key: 'password',
      type: 'password',
      rules: [
        {
          required: true,
          message: fmt(messages.pwdRequire),
        },
      ],
      formItemProps: {
        autoComplete: 'new-password',
        visibilityToggle: false,
      },
    },

    {
      label: fmt(messages.tag),
      key: 'labels',
      renderFormItem: () => {
        return (
          <Checkbox.Group>
            {labelOptions.map((item: any) => (
              <Checkbox key={item.id} value={item.label}>
                <span className={styles.checkboxItme}>{item.label}</span>
              </Checkbox>
            ))}
            <div>
              <Checkbox value={0}>
                <Input
                  style={{ width: 80, height: 24 }}
                  onChange={(e: any) => setInputValue(e.target.value)}
                  size="small"
                  placeholder="自定义"
                />
              </Checkbox>
            </div>
          </Checkbox.Group>
        );
      },
    },
  ];
};

const AddFrom = CreateBaseForm({
  formProps: { name: 'addcolonyHostForm' },
  messages,
})(field);

const AddHostForm = (props: IProps) => {
  const intl = useIntl();
  const { visible, type, onOk, updateHostList } = props;
  const dispatch = useDispatch();
  const { refersh } = useSelector((state: reducerStates) => state.envManage);
  const formRef = createRef<Ref>();
  const isAlone = type === 'alone';
  const [labelOptions, setLabelOptions] = useState<LabelType[]>([]);
  const [uploadStatus, setUploadStatus] = useState(true);
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);
  const [addStatus, setAddStatus] = useState(false);

  useEffect(() => {
    if (isAlone && visible) {
      getLabelApi().then((res) => {
        const { data } = res;
        setLabelOptions(data);
      });
    }
  }, [visible]);

  const handleSubmit = () => {
    if (isAlone) {
      formRef?.current?.form.validateFields((err: any, values: any) => {
        if (err) return;
        setAddStatus(true);
        setUploadStatus(false);

        const { password, ip, sshPort, user, name, labels } = values;
        const newLabels = labels.map((item: any) => {
          if (item === 0) return inputValue;
          return item;
        });
        const params = {
          ip,
          sshPort,
          user,
          password: password,
          name,
          labels: newLabels,
        };

        postHostDataApi(params)
          .then(() => {
            onOk();
            setInputValue(undefined);
            setUploadStatus(true);
            dispatch(
              envManage.changeEnvStatus({
                refersh: !refersh,
              }),
            );
            message.success(intl.formatMessage(messages.addSuccess));
            formRef?.current?.form.resetFields();
            updateHostList((pre: UpdateHostListType) => ({ ...pre }));
          })
          .finally(() => {
            setAddStatus(false);
          });
      });
    } else {
      setUploadStatus(true);
      setAddStatus(true);
      getImportedNodeApi()
        .then(() => {
          message.success(intl.formatMessage(messages.addSuccess));
          dispatch(
            envManage.changeEnvStatus({
              refersh: !refersh,
            }),
          );
          onOk();
          updateHostList((pre: UpdateHostListType) => ({ ...pre }));
          setUploadStatus(false);
        })
        .finally(() => {
          setAddStatus(false);
        });
    }
  };

  // 下载配置模板文件
  const handleDownloadFile = () => {
    exportExcelDownloadApi().then((res) => {
      const { data } = res;
      downloadFiles(data, '集群配置模板.xlsx');
      message.success(intl.formatMessage(messages.downloadSuccess));
    });
  };

  // 文件上传失败时，下载失败提示文件
  const handleError = (path: string) => {
    exportErrorExcelApi(path).then((res) => {
      const { data } = res;
      downloadFiles(data, '集群配置模板.xlsx');
      message.success(intl.formatMessage(messages.downloadSuccess));
    });
  };

  return (
    <CommonModal
      height="auto"
      visible={visible}
      closable={false}
      className={isAlone ? styles.add_host_form_alone : styles.add_host_form}
      title={isAlone ? intl.formatMessage(messages.addHost) : intl.formatMessage(messages.addHostBatch)}
      onOk={handleSubmit}
      onCancel={onOk}
      destroyOnClose
      footer={[
        <Button disabled={isAlone ? addStatus : uploadStatus} type="primary" key="add" onClick={handleSubmit}>
          {intl.formatMessage(messages.add)}
        </Button>,
        <Button disabled={addStatus} onClick={onOk} key="cancel">
          {intl.formatMessage(messages.cancel)}
        </Button>,
      ]}
    >
      <Spin spinning={addStatus} tip={intl.formatMessage(messages.adding)}>
        {isAlone ? (
          <AddFrom
            labelOptions={labelOptions}
            setInputValue={setInputValue}
            inputValue={inputValue}
            wrappedComponentRef={formRef}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
            initData={{ labels: [], user: 'root', sshPort: '22' }}
          />
        ) : (
          <AddBtachFile
            height={240}
            url="/api/ops-manager/v1/server/node/excel/upload"
            onError={handleError}
            onDownload={handleDownloadFile}
            setUploadStatus={setUploadStatus}
          />
        )}
      </Spin>
    </CommonModal>
  );
};

export default AddHostForm;
